export default "__VITE_ASSET__a0f21d42__"